module.exports = __webpack_public_path__ + "static/percy-e5e2bcba0087414ba14a59ef5dce614f.jpg";